import * as THREE from "three";

const ZERO_VECTOR = new THREE.Vector3(0, 0, 0);

function getGeometryBounds(geometry) {
  if (!geometry) return null;

  if (!geometry.boundingBox && typeof geometry.computeBoundingBox === "function") {
    geometry.computeBoundingBox();
  }

  return geometry.boundingBox || null;
}

export function getBackboardTransformControlsOffset(backboard) {
  const bounds = getGeometryBounds(backboard?.geometry);
  if (!bounds) return ZERO_VECTOR.clone();

  if (typeof backboard.updateMatrix === "function") {
    backboard.updateMatrix();
  }

  const corner = new THREE.Vector3(
    bounds.max.x,
    bounds.min.y,
    (bounds.min.z + bounds.max.z) / 2
  );

  const cornerInParent = corner.applyMatrix4(backboard.matrix);
  const originInParent = ZERO_VECTOR.clone().applyMatrix4(backboard.matrix);

  return cornerInParent.sub(originInParent);
}

export function getBackboardTransformControlsWorldPosition(pointerMesh, backboard) {
  if (typeof pointerMesh?.updateMatrixWorld === "function") {
    pointerMesh.updateMatrixWorld(true);
  }

  const backboardPosition = backboard?.position?.clone ? backboard.position.clone() : ZERO_VECTOR.clone();
  const controlsPosition = backboardPosition.add(getBackboardTransformControlsOffset(backboard));

  return typeof pointerMesh?.localToWorld === "function"
    ? pointerMesh.localToWorld(controlsPosition)
    : controlsPosition;
}

export function getBackboardPositionFromTransformControlsWorldPosition(pointerMesh, backboard, controlsWorldPosition) {
  const controlsPosition = controlsWorldPosition?.clone ? controlsWorldPosition.clone() : ZERO_VECTOR.clone();
  const controlsLocalPosition = typeof pointerMesh?.worldToLocal === "function"
    ? pointerMesh.worldToLocal(controlsPosition)
    : controlsPosition;

  return controlsLocalPosition.sub(getBackboardTransformControlsOffset(backboard));
}
